import { loginSlice, accountsSlice, mapSlice, fillAddressSlice, statusSlice, productSlice, scheduleSlice, orderSlice, causesSlice, apiKeySlice, infoSlice } from "../slices/"

const { configureStore, getDefaultMiddleware } = require("@reduxjs/toolkit")


export default configureStore({
  reducer: {
    login: loginSlice.reducer,
    accounts: accountsSlice.reducer,
    status: statusSlice.reducer,
    fillAddress: fillAddressSlice.reducer,
    map: mapSlice.reducer,
    products: productSlice.reducer,
    schedules: scheduleSlice.reducer,
    order: orderSlice.reducer,
    causes: causesSlice.reducer,
    apiToken: apiKeySlice.reducer,
    info: infoSlice.reducer
  },
  middleware: ( getDefaultMiddleware ) => getDefaultMiddleware({
    serializableCheck: false
  }),
})